import { MachinesDropdown, RepsDropdown } from "@repo/baseCloud/components";

import type { LayerFilterProps } from "../hooks/useUpdateLayerFilter";

export function LayerRepsDropdown({ layer, updateFilter }: LayerFilterProps) {
	// Inactive reps stay listed: the dropdown drops selected ids it cannot find, which would widen a saved layer.
	return (
		<RepsDropdown
			label="Representatives"
			value={layer.reps}
			changeHandler={updateFilter}
			filters={layer}
			onlyActiveReps={false}
		/>
	);
}

export function LayerMachinesDropdown({ layer, updateFilter }: LayerFilterProps) {
	return <MachinesDropdown label="Machines" value={layer.machines} changeHandler={updateFilter} filters={layer} />;
}
